import React from "react";
import type { Theme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";

export const NoticesLayout: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        flexGrow: 1,
        bgcolor: (theme: Theme) => theme.palette.grey[100],
      }}
    >
      <Outlet />
    </Box>
  );
};

export default NoticesLayout;
